import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CheckboxGridService } from './../checkbox-grid.service';

@Component({
  selector: 'checkbox-grid-header',
  templateUrl: './checkbox-grid-header.component.html',
  styleUrls: ['./checkbox-grid-header.component.scss'],
})
export class CheckboxGridHeaderComponent {
  @Input() gridTitle: string;
  @Input() headerCells;
  @Input() isBulkSupported: boolean;
  @Output() bulkUpdated: EventEmitter<any> = new EventEmitter<any>();

  constructor(private checkboxGridService: CheckboxGridService) {}

  public headerCellMap;

  onColumnUpdated(event) {
    this.bulkUpdated.emit(event);
  }
}
